import { render, staticRenderFns } from "./aiHoverBtn.vue?vue&type=template&id=2af2b4d8&scoped=true"
import script from "./aiHoverBtn.vue?vue&type=script&lang=js"
export * from "./aiHoverBtn.vue?vue&type=script&lang=js"
import style0 from "./aiHoverBtn.vue?vue&type=style&index=0&id=2af2b4d8&prod&lang=scss&scoped=true"
import style1 from "./aiHoverBtn.vue?vue&type=style&index=1&id=2af2b4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2b4d8",
  null
  
)

export default component.exports